import { render, staticRenderFns } from "./personalEntrance.vue?vue&type=template&id=3a325e71&scoped=true"
import script from "./personalEntrance.vue?vue&type=script&lang=js"
export * from "./personalEntrance.vue?vue&type=script&lang=js"
import style0 from "./personalEntrance.vue?vue&type=style&index=0&id=3a325e71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a325e71",
  null
  
)

export default component.exports